import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loaderCount: 0,
  timestamp: '',
};

const slice = createSlice({
  name: 'blockingLoader',
  initialState,
  reducers: {
    // Show LOADING
    showLoader(state) {
      (state.loaderCount = state.loaderCount + 1), (state.timestamp = Date.now());
    },

    // Hide ERROR
    hideLoader(state) {
      (state.loaderCount = Math.max(0, state.loaderCount - 1)), (state.timestamp = Date.now());
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { showLoader, hideLoader } = slice.actions;